export default "__VITE_ASSET__C8Y23D60__"